<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '90vw', maxWidth: '500px' }"
  header="Valor de Inscripción"
  (onHide)="onCloseModal()"
  styleClass="inscription-fee-dialog"
>
  <ng-template pTemplate="header">
    <div class="modal-header">
      <i class="pi pi-dollar modal-icon"></i>
      <div class="header-info">
        <span class="modal-title">Valor de Inscripción</span>
        <span class="category-info" *ngIf="category">{{ category.name }} - {{ category.branch }}</span>
      </div>
    </div>
  </ng-template>

  <div class="inscription-fee-content">
    <div class="fee-section">
      <div class="section-header">
        <h4>Configure el valor de inscripción</h4>
        <p class="section-description">
          {{ paymentModel === 'PER_ATHLETE'
              ? 'Establezca el monto que cada atleta debe pagar para participar en esta categoría'
              : 'Establezca el monto que cada equipo debe pagar para participar en esta categoría' }}
        </p>
      </div>

      <div class="fee-input-container">
        <label for="inscriptionFee" class="input-label">
          <i class="pi pi-dollar"></i>
          {{ paymentModel === 'PER_ATHLETE' ? 'Valor de inscripción por atleta (COP)' : 'Valor de inscripción por equipo (COP)' }}
        </label>
        <p-inputNumber
          id="inscriptionFee"
          [(ngModel)]="inscriptionFee"
          mode="currency"
          currency="COP"
          placeholder="Ingrese el valor"
          styleClass="w-full fee-input"
        >
        </p-inputNumber>
        
        <div class="fee-preview" *ngIf="inscriptionFee > 0">
          <i class="pi pi-info-circle"></i>
          <span>{{ paymentModel === 'PER_ATHLETE' ? 'Cada atleta pagará:' : 'Los equipos pagarán:' }} <strong>{{ formatCurrency(inscriptionFee) }}</strong></span>
        </div>
        <small *ngIf="paymentModel === 'PER_ATHLETE'" class="text-sm text-gray-600">
          El total por equipo será este valor multiplicado por la cantidad de atletas
        </small>
      </div>

      <div class="current-fee-info" *ngIf="originalFee > 0">
        <p-tag 
          value="Valor actual: {{ formatCurrency(originalFee) }}" 
          severity="info"
          icon="pi pi-tag">
        </p-tag>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="modal-footer">
      <p-button
        label="Cancelar"
        icon="pi pi-times"
        [text]="true"
        severity="secondary"
        (onClick)="onCloseModal(false)"
        styleClass="cancel-button"
      >
      </p-button>
      <p-button
        label="Guardar"
        icon="pi pi-check"
        severity="success"
        (onClick)="onSave()"
        [disabled]="!hasChanges"
        styleClass="save-button"
      >
      </p-button>
    </div>
  </ng-template>
</p-dialog>